<template>
  <div>
    <div class="flex justify-between mb-4">
      <h2 class="text-2xl font-bold">Domains</h2>
      <div>
        <base-search-input v-model="filter" class="mr-4" />

        <base-button @click="addOpen = !addOpen">
          <span v-if="addOpen">Close</span>
          <span v-else><icon-plus /> Add domain</span>
        </base-button>
      </div>
    </div>

    <AdminDomainsForm v-if="addOpen" @saved="addOpen = false" />

    <div v-if="fetchingList" class="text-blue-400">
      <base-loading class="block text-3xl" />
      Loading
    </div>
    <base-notice v-else-if="empty" class="my-12">
      No domains were added yet
    </base-notice>
    <base-notice v-else-if="list.length === 0" class="my-12">
      No matching domains
    </base-notice>
    <ul v-else class="my-12">
      <li v-for="domain in list" :key="domain.id">
        <div class="flex bg-white mb-1">
          <div class="flex-1 flex justify-between py-2 px-4">
            {{ domain.name }}
            <strong>{{ renderParameters(domain.parameter_list) }}</strong>
          </div>
          <base-button @click="domain.editing = !domain.editing">
            <icon-edit />
          </base-button>
        </div>
        <AdminDomainsForm
          v-if="domain.editing"
          :domain="domain"
          @saved="domain.editing = false"
        />
      </li>
    </ul>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import { computed, ref } from '@vue/composition-api';
import { useFilterable } from '@/composables/useFilterable';
import AdminDomainsForm from './components/AdminDomainsForm';

export default {
  components: {
    AdminDomainsForm,
  },
  setup(props, { root }) {
    const addOpen = ref(false);
    const filter = ref('');
    const list = computed(() => root.$store.state.company.domain.list);
    const filteredList = useFilterable({
      listRef: list,
      key: 'name',
      filterRef: filter,
    });

    return {
      addOpen,
      list: filteredList,
      filter,
    };
  },
  computed: {
    ...mapState('company/domain', ['fetchingList']),
    ...mapGetters('company/domain', ['empty']),
  },
  methods: {
    renderParameters(parameters) {
      return parameters.map(({ value }) => value).join(', ');
    },
  },
};
</script>
